export const LANG_ES_NAME = 'es';

export const LANG_ES_TRANS = {
  'DCleanAdmin': 'Admin De D Clean',
  'helloWorld': 'hola mundo'
};



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/translate/lang-es.ts